import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetID } from '../../models/widget.model';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

// identifier
export const WIDGET_FILTER_SLICE_ID = 'widgetFilter';

interface WidgetFilterStateModel {
  [key: WidgetID]: (CompositeFilterDescriptor | FilterDescriptor)[];
}

interface WidgetFilterActionPayload {
  id: WidgetID;
  filters: (CompositeFilterDescriptor | FilterDescriptor)[];
}

// default state
const initialState: WidgetFilterStateModel = {};

const defaultFilters: (CompositeFilterDescriptor | FilterDescriptor)[] = [];

//slice
const widgetFilterSlice = createSlice({
  name: WIDGET_FILTER_SLICE_ID,
  initialState,
  reducers: {
    setWidgetFilter: (
      state: WidgetFilterStateModel,
      action: PayloadAction<WidgetFilterActionPayload>
    ) => {
      state[action.payload.id] = action.payload.filters;
    },
    clearWidgetFilters: (state: WidgetFilterStateModel, action: PayloadAction<WidgetID>) => {
      state[action.payload] = defaultFilters;
    },
    clearPageLevelFilter: (state: WidgetFilterStateModel) => {
      // eslint-disable-next-line
      state = {};
    },
  },
});

//selectors

export const selectWidgetFilters = createSelector(
  [(state: RootState) => state.widgetFilter, (state: RootState, widgetId: WidgetID) => widgetId],
  (widgetFilter, widgetId): (CompositeFilterDescriptor | FilterDescriptor)[] => {
    return widgetFilter[widgetId] ?? defaultFilters;
  }
);

//actions
export const { setWidgetFilter, clearWidgetFilters, clearPageLevelFilter } =
  widgetFilterSlice.actions;

//reducer
export default widgetFilterSlice;
